import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class FornecedorService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getFornecedores(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/fornecedores/' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getFornecedoresEdit(id) {
		return new Promise((resolve, reject) => {
		  this.http.get(this.url + '/fornecedores/' + id)
			.map(res => res.json())
			.subscribe(data => {
			  this.data = data;
			  resolve(this.data);
			},
			  err => {
				reject(err);
			  });
		});
	  }	

	criaFornecedores(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/fornecedores', {
				fornecedor_nome: data.fornecedor_nome,
				fornecedor_descricao: data.fornecedor_descricao
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaFornecedores(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/fornecedores/' + data.fornecedor_id, {
				fornecedores_nome: data.fornecedores_nome,
				fornecedor_descricao: data.fornecedor_descricao
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	

	apagaFornecedores(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/fornecedores/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}	

